import React from "react";
import { Stethoscope, Heart, Cat } from "lucide-react";

const benefits = [
  {
    icon: Stethoscope,
    title: "Explicaciones Claras",
    description:
      "Entenderás perfectamente qué le pasa a tu compañero y cuáles son los siguientes pasos. Sin tecnicismos, con total transparencia.",
    testid: "benefit-clarity",
    color: "teal",
  },
  {
    icon: Heart,
    title: "Vocación Real",
    description:
      "Las mascotas sienten cuando alguien ama su trabajo. Nuestros pacientes (y sus dueños) vienen felices porque notan el cariño en cada revisión.",
    testid: "benefit-passion",
    color: "rose",
  },
  {
    icon: Cat,
    title: "Expertos en Perros y Gatos",
    description:
      "Conocemos a fondo las necesidades médicas y emocionales de los pequeños animales.",
    testid: "benefit-experts",
    color: "sky",
  },
];

const colorMap = {
  teal: "bg-violet-50 text-violet-600 ring-violet-100",
  rose: "bg-rose-50 text-rose-600 ring-rose-100",
  sky: "bg-cyan-50 text-cyan-600 ring-cyan-100",
};

export const Benefits = () => {
  return (
    <section
      id="beneficios"
      data-testid="benefits-section"
      className="py-20 md:py-28"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl">
          <span className="inline-block text-sm font-semibold text-violet-600 uppercase tracking-wider mb-4">
            ¿Por qué elegir Norivet?
          </span>
          <h2 className="font-['Outfit'] text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-slate-800 leading-tight">
            Tu tranquilidad y la salud de tu mascota son nuestra{" "}
            <span className="text-violet-600">prioridad.</span>
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-3 gap-6 lg:gap-8">
          {benefits.map((b, idx) => {
            const Icon = b.icon;
            return (
              <div
                key={b.testid}
                data-testid={b.testid}
                className="group relative bg-white rounded-3xl p-8 border border-slate-100 shadow-[0_8px_30px_rgb(0,0,0,0.04)] hover:shadow-[0_20px_50px_rgb(0,0,0,0.08)] hover:-translate-y-1 transition-all duration-300"
                style={{ animationDelay: `${idx * 100}ms` }}
              >
                <div
                  className={`w-14 h-14 rounded-2xl flex items-center justify-center ring-1 ${colorMap[b.color]}`}
                >
                  <Icon className="w-7 h-7" strokeWidth={2.2} />
                </div>
                <h3 className="mt-6 font-['Outfit'] text-xl md:text-2xl font-semibold text-slate-800">
                  {b.title}
                </h3>
                <p className="mt-3 text-slate-600 leading-relaxed">
                  {b.description}
                </p>
                <div
                  className={`absolute bottom-0 left-8 right-8 h-0.5 rounded-full bg-gradient-to-r from-transparent via-violet-300 to-transparent opacity-0 group-hover:opacity-100 transition-opacity`}
                />
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
